// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderDetails .col {
  margin: 20px 0;
}
.orderDetails .col div {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.orderDetails .col div .label {
  width: 140px;
  font-weight: bold;
}
.orderDetails .col div span {
  font-size: 16px;
}
.orderDetails .col .cart-product {
  flex-direction: column;
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  padding: 15px;
}
.orderDetails .col .cart-product h6 {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 15px;
}
.orderDetails .col .cart-product .label {
  width: 100px;
  font-weight: bold;
}

.dark .add-product h3 {
  color: var(--darkFont);
}
.dark .orderDetails span {
  color: var(--darkFont);
}`, "",{"version":3,"sources":["webpack://./src/components/Order/OrderDetails/orderDetail.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACN;AAAM;EACE,YAAA;EACA,iBAAA;AAER;AAAM;EACE,eAAA;AAER;AACI;EACE,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;AACN;AAAM;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AAER;AAAM;EACE,YAAA;EACA,iBAAA;AAER;;AAKI;EACE,sBAAA;AAFN;AAMI;EACE,sBAAA;AAJN","sourcesContent":[".orderDetails {\n  .col {\n    margin: 20px 0;\n    div {\n      display: flex;\n      margin-bottom: 10px;\n      flex-wrap: wrap;\n      .label {\n        width: 140px;\n        font-weight: bold;\n      }\n      span {\n        font-size: 16px;\n      }\n    }\n    .cart-product {\n      flex-direction: column;\n      border: 1px solid var(--borderColor);\n      border-radius: 7px;\n      padding: 15px;\n      h6 {\n        font-size: 18px;\n        font-weight: bolder;\n        margin-bottom: 15px;\n      }\n      .label {\n        width: 100px;\n        font-weight: bold;\n      }\n    }\n  }\n}\n.dark {\n  .add-product {\n    h3 {\n      color: var(--darkFont);\n    }\n  }\n  .orderDetails {\n    span {\n      color: var(--darkFont);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
